import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="contacts--currency-positions"
//
// The Site Invoicing tab's currencies drawer (CONEK-8263) is a sortable
// Ui::TagInputComponent, whose chips Tom Select builds in JS. React's
// DraggableComboBox labels each chip with its position — the first currency is
// the Primary, the second the Secondary, every later one Additional — so this
// stamps that label onto the chips and keeps it in step as currencies are
// added, removed or dragged into a new order (all of which re-render or move
// the chips, which the observer sees).
const CHIP_SELECTOR = ".ts-control .item"
const LABEL_ATTRIBUTE = "data-currency-position"

export default class extends Controller {
  static values = {
    primary: String,
    secondary: String,
    additional: String,
  }

  connect() {
    this._observer = new MutationObserver(() => this.label())
    this._observer.observe(this.element, { childList: true, subtree: true })
    this.label()
  }

  disconnect() {
    this._observer?.disconnect()
  }

  label() {
    this.element.querySelectorAll(CHIP_SELECTOR).forEach((chip, index) => {
      const text = this.positionLabel(index)
      let badge = chip.querySelector(`[${LABEL_ATTRIBUTE}]`)
      if (!badge) {
        badge = document.createElement("span")
        badge.setAttribute(LABEL_ATTRIBUTE, "")
        badge.className = "ml-1 text-2xs font-semibold uppercase opacity-70"
        // Before Tom Select's remove "×", so the label reads with the currency.
        chip.insertBefore(badge, chip.querySelector(".remove"))
      }
      // Only write on a change: the write is itself a mutation the observer
      // reports, and an unconditional one would loop.
      if (badge.textContent !== text) badge.textContent = text
      const primary = index === 0 ? "true" : "false"
      if (chip.dataset.primary !== primary) chip.dataset.primary = primary
    })
  }

  positionLabel(index) {
    if (index === 0) return this.primaryValue
    if (index === 1) return this.secondaryValue
    return this.additionalValue
  }
}
